import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/', label: 'Home' },
  { path: '/work', label: 'Work' },
  { path: '/blog', label: 'Blog' },
  { path: '/bookshelf', label: 'Bookshelf' },
];

const Navbar = () => (
  <header className="site-nav">
    <div className="site-nav-inner">
      <Link to="/" className="site-nav-name">
        Vamsi Saladi
      </Link>
      <nav aria-label="Main">
        <ul className="site-nav-links">
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `site-nav-link${isActive ? ' is-active' : ''}`}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  </header>
);

export default Navbar;
